var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header_nav",class:{'header_nav_fixed':_vm.fixedShow}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.png")}})])])
}]

export { render, staticRenderFns }